/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  EventSchema,
  HookConfiguration,
  TestHookActionPayload,
  TestHookActionResult,
  ValidateHookActionPayload,
  ValidateHookActionResult,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventSchemaFromJSON,
    EventSchemaToJSON,
    HookConfigurationFromJSON,
    HookConfigurationToJSON,
    TestHookActionPayloadFromJSON,
    TestHookActionPayloadToJSON,
    TestHookActionResultFromJSON,
    TestHookActionResultToJSON,
    ValidateHookActionPayloadFromJSON,
    ValidateHookActionPayloadToJSON,
    ValidateHookActionResultFromJSON,
    ValidateHookActionResultToJSON,
} from '../models';

export interface CreateHookRequest {
    hookConfiguration: HookConfiguration;
}

export interface DeleteHookRequest {
    hookId: string;
}

export interface GetHookRequest {
    hookId: string;
}

export interface GetHooksRequest {
    eventType?: string;
    enabled?: boolean;
}

export interface TestHookActionRequest {
    hookId: string;
    testHookActionPayload: TestHookActionPayload;
}

export interface UpdateHookRequest {
    hookId: string;
    hookConfiguration: HookConfiguration;
}

export interface ValidateHookActionRequest {
    validateHookActionPayload: ValidateHookActionPayload;
}

/**
 * 
 */
export class HooksApi extends runtime.BaseAPI {

    /**
     * Create a new hook configuration (Roles: admin)
     */
    async createHookRaw(requestParameters: CreateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HookConfiguration>> {
        if (requestParameters.hookConfiguration === null || requestParameters.hookConfiguration === undefined) {
            throw new runtime.RequiredError('HookConfiguration','Required parameter requestParameters.hookConfiguration was null or undefined when calling createHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HookConfigurationToJSON(requestParameters.hookConfiguration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HookConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createHookRequestOptionsRaw(requestParameters: CreateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.hookConfiguration === null || requestParameters.hookConfiguration === undefined) {
            throw new runtime.RequiredError('HookConfiguration','Required parameter requestParameters.hookConfiguration was null or undefined when calling createHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HookConfigurationToJSON(requestParameters.hookConfiguration),
        };
        return responseConfig
    }

    /**
     * Create a new hook configuration (Roles: admin)
     */
    async createHook(requestParameters: CreateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HookConfiguration> {
        const response = await this.createHookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a hook configuration (Roles: admin)
     */
    async deleteHookRaw(requestParameters: DeleteHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling deleteHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteHookRequestOptionsRaw(requestParameters: DeleteHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling deleteHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Delete a hook configuration (Roles: admin)
     */
    async deleteHook(requestParameters: DeleteHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteHookRaw(requestParameters, initOverrides);
    }

    /**
     * Get available event schemas for hook configuration (Roles: admin)
     */
    async getEventSchemasRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventSchema>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/schemas/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventSchemaFromJSON));
    }

    /**
        Request Config Getter
     */
    getEventSchemasRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/schemas/events`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get available event schemas for hook configuration (Roles: admin)
     */
    async getEventSchemas(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventSchema>> {
        const response = await this.getEventSchemasRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a specific hook configuration (Roles: admin)
     */
    async getHookRaw(requestParameters: GetHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HookConfiguration>> {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling getHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HookConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getHookRequestOptionsRaw(requestParameters: GetHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling getHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get a specific hook configuration (Roles: admin)
     */
    async getHook(requestParameters: GetHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HookConfiguration> {
        const response = await this.getHookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all hook configurations (Roles: admin)
     */
    async getHooksRaw(requestParameters: GetHooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HookConfiguration>>> {
        const queryParameters: any = {};

        if (requestParameters.eventType !== undefined) {
            queryParameters['event_type'] = requestParameters.eventType;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HookConfigurationFromJSON));
    }

    /**
        Request Config Getter
     */
    getHooksRequestOptionsRaw(requestParameters: GetHooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.eventType !== undefined) {
            queryParameters['event_type'] = requestParameters.eventType;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get all hook configurations (Roles: admin)
     */
    async getHooks(requestParameters: GetHooksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HookConfiguration>> {
        const response = await this.getHooksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test a hook action (Roles: admin)
     */
    async testHookActionRaw(requestParameters: TestHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestHookActionResult>> {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling testHookAction.');
        }

        if (requestParameters.testHookActionPayload === null || requestParameters.testHookActionPayload === undefined) {
            throw new runtime.RequiredError('TestHookActionPayload','Required parameter requestParameters.testHookActionPayload was null or undefined when calling testHookAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/{hookId}/test`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestHookActionPayloadToJSON(requestParameters.testHookActionPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestHookActionResultFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    testHookActionRequestOptionsRaw(requestParameters: TestHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling testHookAction.');
        }

        if (requestParameters.testHookActionPayload === null || requestParameters.testHookActionPayload === undefined) {
            throw new runtime.RequiredError('TestHookActionPayload','Required parameter requestParameters.testHookActionPayload was null or undefined when calling testHookAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/{hookId}/test`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: TestHookActionPayloadToJSON(requestParameters.testHookActionPayload),
        };
        return responseConfig
    }

    /**
     * Test a hook action (Roles: admin)
     */
    async testHookAction(requestParameters: TestHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestHookActionResult> {
        const response = await this.testHookActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a hook configuration (Roles: admin)
     */
    async updateHookRaw(requestParameters: UpdateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HookConfiguration>> {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling updateHook.');
        }

        if (requestParameters.hookConfiguration === null || requestParameters.hookConfiguration === undefined) {
            throw new runtime.RequiredError('HookConfiguration','Required parameter requestParameters.hookConfiguration was null or undefined when calling updateHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HookConfigurationToJSON(requestParameters.hookConfiguration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HookConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateHookRequestOptionsRaw(requestParameters: UpdateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.hookId === null || requestParameters.hookId === undefined) {
            throw new runtime.RequiredError('hookId','Required parameter requestParameters.hookId was null or undefined when calling updateHook.');
        }

        if (requestParameters.hookConfiguration === null || requestParameters.hookConfiguration === undefined) {
            throw new runtime.RequiredError('HookConfiguration','Required parameter requestParameters.hookConfiguration was null or undefined when calling updateHook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters.hookId))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HookConfigurationToJSON(requestParameters.hookConfiguration),
        };
        return responseConfig
    }

    /**
     * Update a hook configuration (Roles: admin)
     */
    async updateHook(requestParameters: UpdateHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HookConfiguration> {
        const response = await this.updateHookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate action configuration (Roles: admin)
     */
    async validateHookActionRaw(requestParameters: ValidateHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateHookActionResult>> {
        if (requestParameters.validateHookActionPayload === null || requestParameters.validateHookActionPayload === undefined) {
            throw new runtime.RequiredError('ValidateHookActionPayload','Required parameter requestParameters.validateHookActionPayload was null or undefined when calling validateHookAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/hooks/actions/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateHookActionPayloadToJSON(requestParameters.validateHookActionPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateHookActionResultFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    validateHookActionRequestOptionsRaw(requestParameters: ValidateHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.validateHookActionPayload === null || requestParameters.validateHookActionPayload === undefined) {
            throw new runtime.RequiredError('ValidateHookActionPayload','Required parameter requestParameters.validateHookActionPayload was null or undefined when calling validateHookAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/hooks/actions/validate`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ValidateHookActionPayloadToJSON(requestParameters.validateHookActionPayload),
        };
        return responseConfig
    }

    /**
     * Validate action configuration (Roles: admin)
     */
    async validateHookAction(requestParameters: ValidateHookActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateHookActionResult> {
        const response = await this.validateHookActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
